import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DataGridConfig } from '@shared/components/data-grid/data-grid-config';
import { QuestionnaireService } from '@app/shared/services/questionnaire.service';
import { NotificationService } from '@app/shared/components/notification/notification.service';
import { GridRefreshService } from '@app/shared/services/grid-refresh.service';
import { Notification } from '@shared/components/notification/models/notification.model';
import { interval, Subscription } from 'rxjs';
import { IGenerateDocumentStatusResponse } from '@app/shared/models/peninsulaDocument';
import { GenerateDocumentsService } from '@app/shared/services/generate-documents.service';

@Component({
  selector: 'db-generate-documents-dialog',
  templateUrl: './generate-documents-dialog.component.html',
  styleUrls: ['./generate-documents-dialog.component.scss']
})
export class GenerateDocumentsDialogComponent implements OnInit {
  dataGridConfig: DataGridConfig;
  rowData: any[];
  selectedRowData: any[] = [];
  subscription: Subscription = new Subscription();
  clearStatusTimeout: any;
  isSelectionLimitExceeded: boolean = false;


  constructor(
    private questionnaireService: QuestionnaireService,
    private notificationService: NotificationService,
    private gridRefreshService: GridRefreshService,
    public generateDocumentsDialogRef: MatDialogRef<GenerateDocumentsDialogComponent>,
    private generateDocumentsService: GenerateDocumentsService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
    this.configureGrid();
    this.initializeRowData();
  }

  configureGrid() {
    this.dataGridConfig = {
      columnDefs: [
        {
          headerName: 'Document',
          field: 'title',
          minWidth: 500
        },
        {
          headerName: 'Version Number',
          field: 'version',
          minWidth: 100
        },
        {
          headerName: 'Status',
          field: 'status',
          minWidth: 100
        }
      ],
      defaultColDef: {
        headerCheckboxSelection: this.isFirstColumn,
        checkboxSelection: this.isFirstColumn
      },
      rowSelection: 'multiple',
      selectionLimit: 5
    };
  }

  isFirstColumn(params) {
    const displayedColumns = params.columnApi.getAllDisplayedColumns();
    const thisIsFirstColumn = displayedColumns[0] === params.column;
    return thisIsFirstColumn;
  }

  initializeRowData() {
    this.questionnaireService.getDraftDocuments(this.data.questionnaireId)
      .subscribe(data => {
        this.rowData = data;
      });
  }

  selectedRows($event) {
    this.selectedRowData = $event;
    this.isSelectionLimitExceeded = this.selectedRowData.length > this.dataGridConfig.selectionLimit;
  }

  generateBespokeDocuments() {
    const documentIds = this.selectedRowData.map(row => row.id.toString());

    this.questionnaireService.createGenerateDocuments(documentIds, this.data.answerSetId, this.data.client.clientId, this.data.client.clientCan)
      .subscribe((response) => {
        this.generateDocumentsDialogRef.close();
        this.generateDocumentStatus(response.instanceId);
      }, error => {
        console.error('generateBespokeDocuments Error: ', error);
      });
  }

  generateDocumentStatus(instanceId: string) {
    this.generateDocumentsService.setStatus('Pending');
    this.subscription = interval(10000).subscribe(() => {
      this.checkDocumentStatus(instanceId);
    });
  }

  checkDocumentStatus(instanceId: string): void {
    this.questionnaireService.generateDocumentStatus(instanceId)
      .subscribe((response: IGenerateDocumentStatusResponse) => {
        this.generateDocumentsService.setStatus(response.runtimeStatus);
        if (response.runtimeStatus === 'Completed') {
          this.subscription.unsubscribe();
          this.gridRefreshService.refreshGridData();
          this.notificationService.notification(
            new Notification('success', 'Document(s) Generated', 'The selected document(s) have been successfully generated.')
          );

          this.resetDocumentStatus();
        }
      }, error => {
        console.error('generateDocumentStatus Error: ', error);
      });
  }

  resetDocumentStatus() {
    if (this.clearStatusTimeout) {
      clearTimeout(this.clearStatusTimeout);
    }

    this.clearStatusTimeout = setTimeout(() => {
      this.generateDocumentsService.setStatus('');
    }, 5000);
  }
}
